import type { NetworkData } from '@dynamic-labs-sdk/client';
import { SuiClient } from '@mysten/sui/client';
import { MIST_PER_SUI } from '@mysten/sui/utils';

export const fetchSuiBalance = async ({
  address,
  networkData,
}: {
  address: string;
  networkData: NetworkData;
}): Promise<string | null> => {
  // Create a SuiClient using the provided RPC URL.
  const suiClient = new SuiClient({
    url: networkData.rpcUrls.http[0],
  });

  const balanceInMist = await suiClient.getBalance({
    owner: address,
  });

  // Balance comes back as MIST, 1 SUI = 1e9 MIST
  const balance = Number(balanceInMist.totalBalance) / Number(MIST_PER_SUI);

  if (Number.isNaN(balance)) {
    return null;
  }

  return balance.toString();
};
